import { useNavigate } from "react-router-dom";

const ProductCard = ({ product, addToCart }) => {
  const navigate = useNavigate();

  const verDetalle = () => {
    navigate(`/detalle/${product.id}`);
  };

  return (
    <div className="col mb-4">
      <div className="card h-100 shadow-sm border-0 rounded-4 position-relative">
        
        {/* Badge de stock */}
        <span
          className={`badge position-absolute ${
            product.Stock > 0 ? "bg-success" : "bg-danger"
          }`}
          style={{ top: "0.75rem", right: "0.75rem", zIndex: 2 }}
        >
          {product.Stock > 0 ? "En Stock" : "Agotado"}
        </span>

        {/* Botón Ver Detalle arriba a la izquierda */}
          <button
            onClick={verDetalle}
            className="position-absolute bg-white border border-primary text-primary fw-semibold shadow-sm"
            style={{
              top: "0.6rem",
              left: "0.6rem",
              zIndex: 2,
              borderRadius: "16px",
              fontSize: "0.78rem",
              padding: "3px 10px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              transition: "all 0.2s ease-in-out",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0d6efd";
              e.target.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#0d6efd";
            }}
          >
            <i className="bi bi-eye"></i>
            Ver Detalle
          </button>


        {/* Imagen del producto */}
        <div className="text-center p-3">
          <img
            className="card-img-top"
            src={product.Image}
            alt={product.name}
            style={{
              height: "180px",
              objectFit: "contain",
              display: "block",
              WebkitUserSelect: "none",
              margin: "auto",
              backgroundColor: "hsl(0, 0%, 90%)",
              transition: "background-color 300ms",
            }}
          />
        </div>

        {/* Body */}
        <div className="card-body text-center">
          <h5 className="fw-bold">{product.name}</h5>

          <div className="d-flex justify-content-center text-warning mb-2">
            {Array.from({ length: product.Estrellas }).map((_, index) => (
              <i key={index} className="bi bi-star-fill"></i>
            ))}
          </div>

          <h6 className="text-primary fw-bold mb-3">
            S/. {Number(product.price).toFixed(2)}
          </h6>
        </div>

        {/* Footer con botón agregar al carrito */}
        <div className="card-footer border-0 bg-transparent text-center pb-4">
          <button
            className="btn btn-primary rounded-pill px-4 shadow-sm"
            disabled={product.Stock === 0}
            onClick={() => addToCart(product)}
          >
            🛒 {product.Stock > 0 ? "Agregar al carrito" : "Agotado"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
